// extracted by mini-css-extract-plugin
export var active = "_hx-2";
export var recordingDot = "_hx-1";
export var recordingIndicator = "_hx-0";